import { SubtleButton } from "@mgdx/ui/components/SubtleButton";

import { AccountDeleteView, Props as AccountDeleteViewProps } from "../AccountDeleteView";

export type AgreementNewTermsWithdrawViewProps = Pick<AccountDeleteViewProps, "deleteUser"> & {
  onClickShowReason: VoidFunction;
};

export const AgreementNewTermsWithdrawView = ({
  deleteUser,
  onClickShowReason,
}: AgreementNewTermsWithdrawViewProps) => {
  return (
    <>
      <AccountDeleteView deleteUser={deleteUser} />

      <div>
        <SubtleButton onClick={onClickShowReason}>前へ戻る</SubtleButton>
      </div>
    </>
  );
};
